<template>
  <div class="box3">
    <img class="title" src="../../../assets/coursePage/java/box3/title.png"/>
    <div>
    <div class="box1">
        <pageTitle title="AI时代，懂Java的AI开发者<br/> 将成为时代的新宠儿" />
        <div class="subject-content">
          <img src="../../../assets/coursePage/java/box3/1.png"/>
          <p>现在就加入“Al智能应用开发（Java)”课程，<br/>
          掌握Java+Al技能，抓住AI时代的高薪机遇吧！</p>
          <a class="btn" @click="zixun">AI智能应用开发（Java）课程</a>
        </div>
    </div>
    <div class="box1">
      <pageTitle title="AI时代 <br/>软件开发人才需求爆发式增长" />
      <div class="subject-content">
        <img src="../../../assets/coursePage/java/box3/2.png"/>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  methods:{
    zixun(){
       this.clickZiXun()
    }
  }
};
</script>

<style lang="less" scoped>
.box3 {
  padding: 0px 0 88px;
  width: 100%;
  .title{
    width: 100%;
    display: block;
    margin-bottom: 80px;
  }
  .box1:first-child{
    padding-bottom:80px;
     background: linear-gradient( 180deg, #FFFFFF 0%, #FAFBFF 100%);
  }
.box1:last-child{
  margin-top:80px;
 
 
}
  .subject-content {
   
    margin-top: 48px;
    padding: 0 32px;
    img{
      width:100%;
    }
    p{
      font-family: PingFangSC, PingFang SC;
font-weight: 600;
font-size: 30px;
color: #1B63FF;
line-height: 42px;
text-align: center;
font-style: normal;
margin: 48px auto;
    }
    .btn{
    width: 480px;
height: 88px;
display: block;
margin:0 auto;
background: linear-gradient( 270deg, #FF7A87 0%, #FF4659 100%);
border-radius: 48px;
font-family: PingFangSC, PingFang SC;
font-weight: 500;
font-size: 30px;
color: #FFFFFF;
line-height: 88px;
text-align: center;
font-style: normal;
  }
  }
}
</style>
